// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".IdCardButtonLv_reset-list_1rks7{margin:0;padding:0;list-style:none;display:block}.IdCardButtonLv_uppercase-sm_iBoc9{font-size:12px;text-transform:uppercase;letter-spacing:.03667em}.IdCardButtonLv_icon_10e5B{display:block;width:27px;height:auto;margin-right:8px}", ""]);
// Exports
exports.locals = {
	"reset-list": "IdCardButtonLv_reset-list_1rks7",
	"uppercase-sm": "IdCardButtonLv_uppercase-sm_iBoc9",
	"icon": "IdCardButtonLv_icon_10e5B"
};
module.exports = exports;
